const data = {
    "Soccer": [],
    "Rugby": [
        { name: "Attack" },
        { name: "Conditioning" },
        { name: "Defence" },
        { name: "Passing" },
        { name: "Ruck" },
        {
            name: "Difficulty",
            value: [
                "Advanced",
                "Intermediate",
                "Beginner"
            ]
        },
        {
            name: "Player",
            value: [
                "All",
                "Forwards",
                "Backs"
            ]
        },
        {
            name: "Location",
            value: [
                "Gym",
                "Field"
            ]
        },
        {
            name: "Intensity rating",
            value: [
                "Intensity 1",
                "Intensity 2",
                "Intensity 3",
                "Intensity 4",
                "Intensity 5"
            ]
        },
        {
            name: "Size",
            value: [
                "Individual",
                "Small group",
                "Large group"
            ]
        },
        {
            name: "Position",
            value: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
        }
    ],
    "Cricket": []
}

export default data;


// WEBPACK FOOTER //
// ./src/components/TrainingCategories.js